import React from 'react';
import styles from './Icon.module.sass';

export enum ICONS {
    HOME,
    BUSINESS_UNIT,
    BUSINESS,
    VACANCY,
    CANDIDATE,
    CONTACT,
    CMS,
    PROFILE,
    SETTINGS,
    USERS,
    LAYOUT,
    DATASETS,
    FIELDS,
    RELATION,
    STAR,
    CLOSE,
    CROSS,
    CHEVRON_DOWN,
    LOGOUT,
    ADD,
    COLUMNS,
    GROWING_PEOPLE_WEBSITE,
    INDEED,
    TECHNICUS,
    EURO,
    LIVE,
    MODULE,
    MAILGUN
}

export const Icon = ({type, size, appearance, isBoxed, isOutlined, isCircled}: any) => {
    const specialClass = () => {
        switch (type) {
            case ICONS.CONTACT:
                return styles['icon--contact'];
            case ICONS.SETTINGS:
                return styles['icon--settings'];
            case ICONS.BUSINESS:
                return styles['icon--business'];
            case ICONS.BUSINESS_UNIT:
                return styles['icon--businessunit'];
            case ICONS.CANDIDATE:
                return styles['icon--candidate'];
            case ICONS.VACANCY:
                return styles['icon--vacancy'];
            default:
                return styles['icon--default'];
        }
    }

    return <div className={`${styles['icon']}
        ${styles['icon--'+size]}
        ${isBoxed ? styles['icon--box'] : ''}
        ${isOutlined ? styles['icon--outlined'] : ''}
        ${isCircled ? styles['icon--circled'] : ''}
        ${appearance ? styles['icon--'+appearance] : ''}        
        ${specialClass()}
        `}>
        <svg width="64" height="64" x="0px" y="0px" viewBox="0 0 64 64">
            { type == ICONS.EURO && <g>
                <path d="M49.5,46c-2.8,3-6.5,4.6-10.2,4.6c-6.2,0-11.5-4.3-14-10.6h17.1c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7
                    H23.9c-0.1-0.9-0.2-1.8-0.2-2.7c0-1,0.1-2,0.2-3h18.4c1.5,0,2.7-1.2,2.7-2.7c0-1.5-1.2-2.7-2.7-2.7h-17c2.6-6.1,7.8-10.2,13.9-10.2
                    c3.8,0,7.4,1.6,10.2,4.6c1,1.1,2.7,1.1,3.8,0.1c1.1-1,1.1-2.7,0.1-3.8C49.6,10.2,44.5,8,39.3,8c-9,0-16.6,6.5-19.6,15.6h-7.2
                    c-1.5,0-2.7,1.2-2.7,2.7c0,1.5,1.2,2.7,2.7,2.7h6c-0.1,1-0.2,2-0.2,3c0,0.9,0,1.8,0.1,2.7h-6c-1.5,0-2.7,1.2-2.7,2.7
                    c0,1.5,1.2,2.7,2.7,2.7h7.1C22.5,49.3,30.2,56,39.3,56c5.2,0,10.3-2.2,14.1-6.3c1-1.1,1-2.8-0.1-3.8C52.2,44.9,50.5,44.9,49.5,46z"
                    />
            </g> }
            { type == ICONS.HOME && <g>
                <path d="M55.19,29.85l-7.27-7.27V14.17a2.75,2.75,0,0,0-5.5,0v2.9L37,11.66a7.24,7.24,0,0,0-10,0L8.81,29.85a2.75,2.75,0,1,0,3.89,3.89L30.89,15.55a1.61,1.61,0,0,1,2.22,0L51.3,33.74a2.75,2.75,0,0,0,3.89-3.89Z" />
                <path d="M33,20.77a1.38,1.38,0,0,0-1.92,0l-16,16a1.33,1.33,0,0,0-.4,1V49.39a5,5,0,0,0,5,5h7.92V42.08h8.94V54.35h7.92a5,5,0,0,0,5-5V37.73a1.33,1.33,0,0,0-.4-1Z" />
            </g> }
            { type == ICONS.BUSINESS && <g id="_001-business-and-trade" transform="translate(0 -0.178)">
                <path id="Path_2" d="M34.1,11.7l-22-3.3c-1-0.2-2.1,0.1-2.8,0.8C8.5,9.9,8,10.8,8,11.9V54c0,1.1,0.9,2,2,2h6.5V45.5
                    c0-1.9,1.6-3.5,3.5-3.5c0,0,0,0,0,0h5c1.9,0,3.5,1.6,3.5,3.5c0,0,0,0,0,0V56H37V15.2C37,13.5,35.8,12,34.1,11.7z M19,37.5h-3
                    c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S19.8,37.5,19,37.5z M19,31.5h-3c-0.8,0-1.5-0.7-1.5-1.5
                    s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S19.8,31.5,19,31.5z M19,25.5h-3c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5
                    c0,0,0,0,0,0h3c0.8,0,1.5,0.7,1.5,1.5S19.8,25.5,19,25.5z M19,19.5h-3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3
                    c0.8,0,1.5,0.7,1.5,1.5S19.8,19.5,19,19.5z M29,37.5h-3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5
                    S29.8,37.5,29,37.5z M29,31.5h-3c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S29.8,31.5,29,31.5z M29,25.5h-3
                    c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5c0,0,0,0,0,0h3c0.8,0,1.5,0.7,1.5,1.5S29.8,25.5,29,25.5z M29,19.5h-3
                    c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S29.8,19.5,29,19.5z"/>
                <path id="Path_3" d="M53.2,29.7l-14.2-3V56h13.5c1.9,0,3.5-1.6,3.5-3.5V33.1C56,31.5,54.9,30,53.2,29.7z M48.5,50h-3
                    c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S49.3,50,48.5,50L48.5,50L48.5,50z M48.5,44h-3
                    c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S49.3,44,48.5,44L48.5,44L48.5,44z M48.5,38h-3
                    c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h3c0.8,0,1.5,0.7,1.5,1.5S49.3,38,48.5,38L48.5,38L48.5,38z"/>
            </g> }
            { type == ICONS.BUSINESS_UNIT && <g>
                <defs>
                    <rect id="SVGID_1_" x="17.4" y="8" width="29.2" height="48"/>
                </defs>
                <clipPath id="SVGID_00000080173327627364735890000015868916908958308793_">
                    <use xlinkHref="#SVGID_1_" style={{overflow: 'visible'}} />
                </clipPath>
                <g id="Group_11" style={{clipPath: 'url(#SVGID_00000080173327627364735890000015868916908958308793)'}}>
                    <path id="Path_14" d="M43.6,11.4L21.5,8c-1-0.2-2.1,0.1-2.9,0.8c-0.8,0.7-1.2,1.7-1.2,2.7V54c0,1.1,0.9,2,2,2H26V45.4
                        c0-1.9,1.6-3.5,3.5-3.5c0,0,0,0,0,0h5c1.9,0,3.5,1.6,3.5,3.5c0,0,0,0,0,0V56h8.6V14.9C46.6,13.2,45.4,11.7,43.6,11.4 M28.5,37.4
                        h-3c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8-0.1,1.6,0.6,1.6,1.4c0.1,0.8-0.6,1.6-1.4,1.6
                        C28.6,37.4,28.6,37.4,28.5,37.4 M28.5,31.3h-3c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8-0.1,1.6,0.6,1.6,1.4
                        c0.1,0.8-0.6,1.6-1.4,1.6C28.6,31.3,28.6,31.3,28.5,31.3 M28.5,25.3h-3c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3
                        c0.8-0.1,1.6,0.6,1.6,1.4c0.1,0.8-0.6,1.6-1.4,1.6C28.6,25.3,28.6,25.3,28.5,25.3 M28.5,19.2h-3c-0.8-0.1-1.5-0.8-1.4-1.6
                        c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8-0.1,1.6,0.6,1.6,1.4c0.1,0.8-0.6,1.6-1.4,1.6C28.6,19.2,28.6,19.2,28.5,19.2 M38.5,37.4h-3
                        c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8,0.1,1.5,0.8,1.4,1.6C39.9,36.7,39.3,37.3,38.5,37.4 M38.5,31.3h-3
                        c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8,0.1,1.5,0.8,1.4,1.6C39.9,30.7,39.3,31.3,38.5,31.3 M38.5,25.3h-3
                        c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8,0.1,1.5,0.8,1.4,1.6C39.9,24.6,39.3,25.2,38.5,25.3 M38.5,19.2h-3
                        c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.7,0.6-1.3,1.4-1.4h3c0.8,0.1,1.5,0.8,1.4,1.6C39.9,18.6,39.3,19.2,38.5,19.2"/>
                </g>
            </g>}
            { type == ICONS.CANDIDATE && <g id="_003-user" data-name="003-user">
                <g id="Group_6" data-name="Group 6">
                    <g id="Group_5" data-name="Group 5">
                        <path id="Path_6" data-name="Path 6" d="M32,8A12.66,12.66,0,1,0,44.66,20.66h0A12.68,12.68,0,0,0,32,8Z" />
                    </g>
                </g>
                <g id="Group_8" data-name="Group 8">
                    <g id="Group_7" data-name="Group 7">
                        <path id="Path_7" data-name="Path 7" d="M47.74,41.58a18,18,0,0,0-12.93-5.46H29.19a18.07,18.07,0,0,0-12.94,5.46,18.43,18.43,0,0,0-5.34,13A1.41,1.41,0,0,0,12.31,56H51.69a1.41,1.41,0,0,0,1.4-1.41A18.4,18.4,0,0,0,47.74,41.58Z" />
                    </g>
                </g>
            </g> }
            { type == ICONS.VACANCY && <g id="_002-contract" transform="translate(0 -10.759)">
                <g id="Group_2" transform="translate(0 10.759)">
                    <g id="Group_1">
                        <path id="Path_4" d="M43,42.1c0.1-0.3,0.2-0.5,0.4-0.7l7.1-7.1V11.9c0-0.8-0.7-1.5-1.5-1.5H16.1
                            c-0.8,0-1.5,0.7-1.5,1.5v42.9c0,0.8,0.7,1.5,1.5,1.5h32.9c0.8,0,1.5-0.7,1.5-1.5v-7.2L50,48c-0.2,0.2-0.4,0.3-0.7,0.4l-6,1.5
                            c-0.8,0.2-1.7-0.3-1.9-1.1c-0.1-0.3-0.1-0.5,0-0.8L43,42.1z M24,20H41c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H24
                            c-0.8,0-1.5-0.7-1.5-1.5S23.2,20,24,20z M24,25.9H41c0.8,0,1.5,0.7,1.5,1.5S41.8,29,41,29H24c-0.8,0-1.5-0.7-1.5-1.5
                            S23.2,25.9,24,25.9z M24,31.8H41c0.8,0,1.5,0.7,1.5,1.5s-0.7,1.5-1.5,1.5H24c-0.8,0-1.5-0.7-1.5-1.5S23.2,31.8,24,31.8z
                            M32.5,46.6H24c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h8.5c0.8,0,1.5,0.7,1.5,1.5S33.4,46.6,32.5,46.6z M41,40.7H24
                            c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5H41c0.8,0,1.5,0.7,1.5,1.5C42.5,40,41.8,40.7,41,40.7L41,40.7z"/>
                    </g>
                </g>
                <g id="Group_4" transform="translate(25.406 26.157)">
                    <g id="Group_3">
                        <path id="Path_5" d="M34.9,13.4L20.5,27.8l-0.8,3l3-0.8l14.4-14.4L34.9,13.4z"/>
                    </g>
                </g>
            </g> }
            { type == ICONS.CONTACT && <g>
                <path d="M21.88,23.6a5.89,5.89,0,0,1-6,6h-4.4v4.6h4.4a6,6,0,0,1,0,12h-4.4v3.4a6.32,6.32,0,0,0,6.4,6.4h27.8a6.32,6.32,0,0,0,6.4-6.4V14.4A6.32,6.32,0,0,0,45.68,8H17.88a6.32,6.32,0,0,0-6.4,6.4v3.2h4.4a6.15,6.15,0,0,1,6,6Zm12.8-5a4.53,4.53,0,0,1,4.6,4.6,4.65,4.65,0,0,1-4.6,4.6,4.53,4.53,0,0,1-4.6-4.6,4.65,4.65,0,0,1,4.6-4.6Zm0,12.8a8.94,8.94,0,0,1,8.8,8.4,2,2,0,0,1-2,2H28.08a2,2,0,0,1-2-2,8.62,8.62,0,0,1,8.6-8.4Z" />
                <path d="M9.48,25.8h6.4a2,2,0,0,0,0-4H9.48a2,2,0,0,0,0,4Z" />
                <path d="M9.48,42.2h6.4a2,2,0,0,0,0-4H9.48a2,2,0,0,0,0,4Z" />
            </g> }



            { type == ICONS.USERS && <g>
                <g>
                    <g>
                        <path d="M49.1,33.6h-3.7c0.4,1,0.6,2.2,0.6,3.3v14c0,0.5-0.1,1-0.2,1.4h6.1c2.3,0,4.2-1.9,4.2-4.2v-7.6
                            C56,36.7,52.9,33.6,49.1,33.6z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M18.1,36.9c0-1.2,0.2-2.3,0.6-3.3h-3.7c-3.8,0-6.9,3.1-6.9,6.9v7.6c0,2.3,1.9,4.2,4.2,4.2h6.1
                            c-0.2-0.4-0.2-0.9-0.2-1.4V36.9z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M36.2,30h-8.5c-3.8,0-6.9,3.1-6.9,6.9v14c0,0.8,0.6,1.4,1.4,1.4h19.6c0.8,0,1.4-0.6,1.4-1.4v-14
                            C43.2,33.1,40.1,30,36.2,30z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M32,11.6c-4.6,0-8.3,3.7-8.3,8.3c0,3.1,1.7,5.8,4.3,7.3c1.2,0.7,2.6,1.1,4.1,1.1c1.5,0,2.9-0.4,4.1-1.1
                            c2.5-1.4,4.3-4.2,4.3-7.3C40.3,15.4,36.6,11.6,32,11.6z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M17.4,19.4c-3.4,0-6.2,2.8-6.2,6.2s2.8,6.2,6.2,6.2c0.9,0,1.7-0.2,2.5-0.5c1.3-0.6,2.4-1.6,3-2.8
                            c0.5-0.9,0.7-1.9,0.7-2.9C23.6,22.2,20.8,19.4,17.4,19.4z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M46.6,19.4c-3.4,0-6.2,2.8-6.2,6.2c0,1.1,0.3,2.1,0.7,2.9c0.7,1.2,1.7,2.2,3,2.8c0.8,0.3,1.6,0.5,2.5,0.5
                            c3.4,0,6.2-2.8,6.2-6.2S50.1,19.4,46.6,19.4z"/>
                    </g>
                </g>
            </g> }
            { type == ICONS.LAYOUT && <g>
                <g>
                    <g>
                        <path d="M28,8H10c-1.1,0-2,0.9-2,2v22c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V10C30,8.9,29.1,8,28,8z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M54,30H36c-1.1,0-2,0.9-2,2v22c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V32C56,30.9,55.1,30,54,30z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M28,38H10c-1.1,0-2,0.9-2,2v14c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V40C30,38.9,29.1,38,28,38z"/>
                    </g>
                </g>
                <g>
                    <g>
                        <path d="M54,8H36c-1.1,0-2,0.9-2,2v14c0,1.1,0.9,2,2,2h18c1.1,0,2-0.9,2-2V10C56,8.9,55.1,8,54,8z"/>
                    </g>
                </g>
            </g> }
            { type == ICONS.FIELDS && <g>
                <path d="M40.8,8.8H9.4c-0.8,0-1.4,0.9-1.4,2v8c0,1.1,0.6,2,1.4,2h31.4c0.8,0,1.4-0.9,1.4-2v-8
	C42.3,9.7,41.6,8.8,40.8,8.8z"/>
                <path d="M54,26.8H10c-1.1,0-2,0.9-2,2v8c0,1.1,0.9,2,2,2h44c1.1,0,2-0.9,2-2v-8C56,27.7,55.1,26.8,54,26.8z"/>
                <path d="M48.5,44.8H9.8c-1,0-1.8,0.9-1.8,2v8c0,1.1,0.8,2,1.8,2h38.7c1,0,1.8-0.9,1.8-2v-8
                    C50.3,45.7,49.5,44.8,48.5,44.8z"/>
                </g> }
            { type == ICONS.RELATION && <g>
                <path d="M13.75,28.55l4.94-4.93L16,20.92A3.49,3.49,0,0,1,20.92,16l11.9,11.9L37.75,23l-11.9-11.9A10.46,10.46,0,0,0,11.06,25.85Z" />
                <path d="M50.25,35.45l-4.94,4.93,2.7,2.7A3.49,3.49,0,1,1,43.08,48l-11.9-11.9L26.25,41l11.9,11.9A10.46,10.46,0,1,0,52.94,38.15Z" />
                <path d="M43.08,16A3.49,3.49,0,1,1,48,20.92l-11.9,11.9L41,37.75l11.9-11.9A10.46,10.46,0,0,0,38.15,11.06l-2.7,2.69,4.93,4.94Z" />
                <path d="M20.92,48A3.49,3.49,0,1,1,16,43.08l11.9-11.9L23,26.25l-11.9,11.9A10.46,10.46,0,0,0,25.85,52.94l2.7-2.69-4.93-4.94Z" />
            </g>

            }
            { type == ICONS.DATASETS && <g id="_x30_25---Centralised">
                <path id="Path" d="M25.6,16c0.1,0,0.3,0,0.4,0l2.5,8.8h1.7l-2.7-9.3c1.7-1,2.5-3.1,1.7-5s-2.8-2.8-4.7-2.3
                    s-3.2,2.4-2.9,4.4S23.6,16,25.6,16L25.6,16z"/>
                <path id="Path_00000104668847047747740260000011470129294420923024_" d="M52,14.4c-1.3,0-2.6,0.7-3.3,1.8
                    s-0.9,2.5-0.4,3.8l-8.7,6c0.2,0.4,0.4,0.8,0.4,1.3v0.4l9.2-6.4c1.3,1.3,3.3,1.5,4.8,0.6c1.6-0.9,2.3-2.8,1.8-4.5
                    C55.4,15.6,53.8,14.4,52,14.4z"/>
                <path id="Path_00000040567826212938322920000013838249513239534474_" d="M49.6,29.6c-1.5,0-2.8,0.8-3.5,2.1L40,29.8
                    v0.6c0,0.4-0.1,0.7-0.2,1l5.9,1.8c0,0.1,0,0.3,0,0.4c0,2.2,1.8,4,4,4s4-1.8,4-4S51.8,29.6,49.6,29.6z"/>
                <path id="Path_00000182511545048484115690000003541099069807492799_" d="M44,48c-0.5,0-0.9,0.1-1.3,0.2l-5.3-9h-1.8
                    l5.8,9.9c-1.4,1.3-1.7,3.4-0.7,5c1,1.6,3.1,2.3,4.8,1.6c1.8-0.7,2.8-2.6,2.5-4.5C47.5,49.3,45.9,48,44,48z"/>
                <path id="Path_00000098927267822574522400000000694714618968479624_" d="M21.6,38.4c0-0.3,0-0.6-0.1-0.9l2.5-1.1v-1.8
                    l-3.2,1.4c-1.1-1.6-3.3-2.1-5-1.2c-1.8,0.9-2.6,2.9-2,4.8c0.6,1.9,2.5,3,4.4,2.7S21.6,40.4,21.6,38.4z"/>
                <path id="Path_00000109021690202440053470000010035644452968123820_" d="M15.2,24.8l8.8,4.5v-1.8l-8.1-4.1
                    c0.4-1.7-0.3-3.4-1.7-4.3s-3.3-0.9-4.6,0.2c-1.3,1-1.9,2.8-1.3,4.4s2.1,2.7,3.8,2.7C13.2,26.4,14.4,25.8,15.2,24.8L15.2,24.8z"/>
                <path id="Shape" d="M38.4,27.2c0-0.4-0.4-0.8-0.8-0.8H26.4c-0.4,0-0.8,0.4-0.8,0.8v3.2c0,0.4,0.4,0.8,0.8,0.8h11.2
                    c0.4,0,0.8-0.4,0.8-0.8V27.2z M28.8,29.6H28c-0.4,0-0.8-0.4-0.8-0.8S27.5,28,28,28h0.8c0.4,0,0.8,0.4,0.8,0.8S29.2,29.6,28.8,29.6z
                    M32.8,29.6H32c-0.4,0-0.8-0.4-0.8-0.8S31.5,28,32,28h0.8c0.4,0,0.8,0.4,0.8,0.8S33.2,29.6,32.8,29.6z"/>
                <path id="Shape_00000024696826653046897580000005712288603812740020_" d="M26.4,37.6h11.2c0.4,0,0.8-0.4,0.8-0.8v-3.2
                    c0-0.4-0.4-0.8-0.8-0.8H26.4c-0.4,0-0.8,0.4-0.8,0.8v3.2C25.6,37.2,25.9,37.6,26.4,37.6z M32,34.4h0.8c0.4,0,0.8,0.4,0.8,0.8
                    c0,0.4-0.4,0.8-0.8,0.8H32c-0.4,0-0.8-0.4-0.8-0.8C31.2,34.8,31.5,34.4,32,34.4z M28,34.4h0.8c0.4,0,0.8,0.4,0.8,0.8
                    c0,0.4-0.4,0.8-0.8,0.8H28c-0.4,0-0.8-0.4-0.8-0.8C27.2,34.8,27.5,34.4,28,34.4z"/>
                <path id="Path_00000006669819295805643720000014935239654651743620_" d="M42.4,14.4c0-1.9-1.4-3.6-3.3-3.9
                    c-1.9-0.4-3.8,0.7-4.5,2.5s0,3.8,1.7,4.8l-2.5,7h1.7l2.3-6.5c0.2,0,0.4,0.1,0.6,0.1C40.6,18.4,42.4,16.6,42.4,14.4L42.4,14.4z"/>
                <path id="Path_00000107563200535311844110000005176644343581477779_" d="M26.6,39.2l-5.3,9C20.9,48.1,20.4,48,20,48
                    c-1.9,0-3.6,1.4-4,3.3c-0.4,1.9,0.7,3.8,2.5,4.5c1.8,0.7,3.9,0,4.9-1.6c1-1.6,0.7-3.8-0.7-5.1l5.8-9.9L26.6,39.2z"/>
            </g> }


            { type == ICONS.CMS && <g>
                <path d="M46.06,51.69H41.45l-.94-2.81h-17l-.94,2.81H17.94a1.41,1.41,0,1,0,0,2.81H46.06a1.41,1.41,0,1,0,0-2.81Z" />
                <path d="M46.06,17.94a1.41,1.41,0,1,0,1.41,1.4A1.4,1.4,0,0,0,46.06,17.94Z" />
                <path d="M51.69,9.5H12.22A4.22,4.22,0,0,0,8,13.72v23.9h8.53V33.41A1.41,1.41,0,0,1,17.94,32h2.17a12.63,12.63,0,0,1,.5-1.2l-1.54-1.54a1.41,1.41,0,0,1,0-2l4-4a1.41,1.41,0,0,1,2,0l1.54,1.54a10.47,10.47,0,0,1,1.2-.5V22.16a1.41,1.41,0,0,1,1.41-1.41h5.62a1.41,1.41,0,0,1,1.41,1.41v2.17a10.47,10.47,0,0,1,1.2.5L39,23.29a1.41,1.41,0,0,1,2,0l4,4a1.41,1.41,0,0,1,0,2L43.39,30.8a12.63,12.63,0,0,1,.5,1.2h2.17a1.41,1.41,0,0,1,1.41,1.41v4.21H56V13.72A4.31,4.31,0,0,0,51.69,9.5ZM46.06,23.56a4.22,4.22,0,1,1,4.22-4.22A4.23,4.23,0,0,1,46.06,23.56Z" />
                <path d="M27.78,36.22a4.19,4.19,0,0,0,.27,1.4H36a4.21,4.21,0,1,0-8.17-1.4Z" />
                <path d="M22.51,33.76a1.4,1.4,0,0,1-1.36,1.05H19.34v2.81h5.81a7.25,7.25,0,0,1-.18-1.4,7,7,0,0,1,14.06,0,7.25,7.25,0,0,1-.18,1.4h5.81V34.81H42.85a1.4,1.4,0,0,1-1.36-1.05,9.46,9.46,0,0,0-1-2.51,1.4,1.4,0,0,1,.22-1.71l1.27-1.28-2-2-1.28,1.28a1.4,1.4,0,0,1-1.71.22,9.46,9.46,0,0,0-2.51-1,1.4,1.4,0,0,1-1.05-1.36V23.56H30.59v1.81a1.4,1.4,0,0,1-1.05,1.36,9.46,9.46,0,0,0-2.51,1,1.4,1.4,0,0,1-1.71-.22L24,26.27l-2,2,1.27,1.28a1.4,1.4,0,0,1,.22,1.71A9.46,9.46,0,0,0,22.51,33.76Z" />
                <path d="M8,41.84a4.22,4.22,0,0,0,4.22,4.22H51.69A4.31,4.31,0,0,0,56,41.84v-1.4H8Z" />
            </g> }
            { type == ICONS.SETTINGS && <g id="Layer_2_00000179639400195701360300000010290497240554633387_" transform="translate(-1 -1.804)">
                <path id="Path_12" d="M54.1,26.5c-3.4-0.5-5.8-3.7-5.3-7.1c0.1-0.5,0.2-0.9,0.4-1.4c0.4-1.2,0.1-2.5-0.9-3.3
                    c-2.1-1.8-4.5-3.1-7-4.1c-1.2-0.4-2.5-0.1-3.3,0.9c-1.2,1.5-3,2.4-4.9,2.4c-1.9,0-3.7-0.9-4.9-2.4c-0.8-1-2.1-1.4-3.3-0.9
                    c-2.4,0.9-4.6,2.1-6.6,3.7c-1,0.8-1.4,2.2-0.9,3.4c1.3,3.2-0.2,6.8-3.4,8.1c-0.6,0.2-1.2,0.4-1.8,0.4c-1.3,0.1-2.3,1.1-2.6,2.4
                    c-0.3,1.5-0.4,3-0.4,4.5c0,1.3,0.1,2.5,0.3,3.8c0.2,1.3,1.3,2.3,2.6,2.5c3.4,0.3,6,3.4,5.6,6.8c-0.1,0.7-0.2,1.4-0.5,2
                    c-0.6,1.2-0.2,2.7,0.8,3.5c2.1,1.7,4.4,3.1,7,4c0.3,0.1,0.7,0.2,1,0.2c1,0,1.8-0.5,2.4-1.2c1.2-1.7,3.1-2.7,5.1-2.7
                    c2,0,3.8,0.9,5,2.5c0.8,1.1,2.2,1.5,3.5,1c2.3-0.9,4.5-2.2,6.4-3.8c1-0.8,1.3-2.2,0.9-3.4c-1.3-3.2,0.1-6.8,3.3-8.2
                    c0.5-0.2,1.1-0.4,1.7-0.4c1.3-0.2,2.3-1.2,2.5-2.4c0.3-1.3,0.4-2.7,0.4-4c0-1.4-0.1-2.9-0.4-4.3C56.4,27.6,55.4,26.6,54.1,26.5z
                    M41,33.1c0,4.4-3.6,8-8,8s-8-3.6-8-8c0-4.4,3.6-8,8-8S41,28.7,41,33.1z"/>
            </g> }

            {
                type == ICONS.CLOSE && 
                <path d="M34.8,32l12.6-12.6c0.8-0.8,0.8-2,0-2.8c-0.8-0.8-2-0.8-2.8,0l0,0L32,29.2L19.4,16.6c-0.8-0.8-2-0.8-2.8,0
                c-0.8,0.8-0.8,2,0,2.8L29.2,32L16.6,44.6c-0.8,0.8-0.8,2,0,2.8c0.8,0.8,2,0.8,2.8,0L32,34.8l12.6,12.6c0.8,0.8,2,0.8,2.8,0
                c0.8-0.8,0.8-2,0-2.8L34.8,32z"/>
            }
            {/* { type == ICONS.CLOSE && <path d="M34,32l9.59-9.6a1.41,1.41,0,0,0-2-2L32,30l-9.59-9.59a1.41,1.41,0,0,0-2,2L30,32l-9.6,9.59a1.41,1.41,0,0,0,2,2L32,34l9.59,9.59a1.41,1.41,0,0,0,2-2Z"/> } */}
            { type == ICONS.CHEVRON_DOWN && <path d="M46.29,24.7l-1.45-1.44a2.43,2.43,0,0,0-1.75-.71,2.32,2.32,0,0,0-1.73.71L32,32.62l-9.36-9.36a2.32,2.32,0,0,0-1.73-.71,2.43,2.43,0,0,0-1.75.71L17.73,24.7A2.38,2.38,0,0,0,17,26.45a2.28,2.28,0,0,0,.73,1.74L30.27,40.72a2.27,2.27,0,0,0,1.73.73,2.38,2.38,0,0,0,1.75-.73L46.29,28.19A2.4,2.4,0,0,0,47,26.45,2.49,2.49,0,0,0,46.29,24.7Z"/> }
            { type == ICONS.LOGOUT && <g id="Layer_2" data-name="Layer 2">
                <g id="Laag_1" data-name="Laag 1">
                    <path d="M30,26a2,2,0,0,0-2,2v8a2,2,0,0,1-2,2H20V8a4,4,0,0,0-2.72-3.8l-.6-.2H26a2,2,0,0,1,2,2v6a2,2,0,0,0,4,0V6a6,6,0,0,0-6-6H4.5a1.3,1.3,0,0,0-.21,0C4.19,0,4.1,0,4,0A4,4,0,0,0,0,4V40a4,4,0,0,0,2.72,3.8l12,4A4,4,0,0,0,20,44V42h6a6,6,0,0,0,6-6V28a2,2,0,0,0-2-2Z" />
                    <path d="M47.41,18.59l-8-8a2,2,0,0,0-2.18-.44A2,2,0,0,0,36,12v6H28a2,2,0,0,0,0,4h8v6a2,2,0,0,0,1.23,1.85,2,2,0,0,0,2.18-.44l8-8a2,2,0,0,0,0-2.82Z" />
                </g>
            </g> }
            { type == ICONS.ADD && <path d="M54.12,30.12H33.88V9.88a1.88,1.88,0,0,0-3.76,0V30.12H9.88a1.88,1.88,0,1,0,0,3.76H30.12V54.12a1.88,1.88,0,0,0,3.76,0V33.88H54.12a1.88,1.88,0,1,0,0-3.76Z" /> }
            { type == ICONS.COLUMNS && <g>
                <path d="M10,8a2,2,0,0,0-2,2V54a2,2,0,0,0,2,2H20a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2Z" />
                <path d="M54,8H44a2,2,0,0,0-2,2V54a2,2,0,0,0,2,2H54a2,2,0,0,0,2-2V10A2,2,0,0,0,54,8Z" />
                <path d="M25,10V54a2,2,0,0,0,2,2H37a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H27A2,2,0,0,0,25,10Z" />
            </g> }

            {
                type == ICONS.GROWING_PEOPLE_WEBSITE && <g id="Group_333" transform="translate(28)">
                    <g>
                        <g id="Group_160" transform="translate(0 0)">
                            <path id="Path_39" d="M12,54.2c-0.2,0.6-0.6,1.1-1.2,1.4c-0.5,0.3-1.1,0.4-1.7,0.4c-1.1,0-2.1-0.8-2.4-1.8l-8.7-21.9
                                l1.4,0.2l-7.9,21.7c-0.3,1-1.3,1.8-2.4,1.8c-0.6,0.1-1.2-0.1-1.8-0.4c-0.5-0.3-0.9-0.8-1.2-1.4L-19,40.3
                                c-0.1-0.4-0.2-0.7-0.2-1.1c0-0.7,0.3-1.5,0.8-2c0.5-0.6,1.3-0.9,2.1-0.8c0.5,0,1.1,0.1,1.5,0.4c0.5,0.3,0.8,0.8,1,1.4l3.6,10.4
                                l-1.5-0.1l8.1-20.9c0.4-1.1,1.5-1.8,2.6-1.8c0.6,0,1.1,0.1,1.6,0.5c0.4,0.3,0.7,0.8,0.9,1.3l8.5,20.9l-1.8,0.1L21.8,9.8
                                c0.3-1.2,1.4-1.9,2.6-1.8c0.7,0,1.4,0.3,1.9,0.8c0.6,0.5,0.9,1.3,0.9,2.1c0,0.2,0,0.4-0.1,0.6 M2.9,18.5c0,2.1-1.7,3.8-3.8,3.8
                                s-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8S2.9,16.4,2.9,18.5L2.9,18.5"/>
                        </g>
                    </g>
                </g>
            }
            {
                type == ICONS.INDEED && <g id="Group_342" transform="translate(1)">
                    <g>
                        <g id="Group_158" transform="translate(-1)">
                            <path id="Path_38" d="M34.5,28.6c-3,1.5-6.6,0.3-8.1-2.6s-0.3-6.6,2.6-8.1s6.6-0.3,8.1,2.6c0,0,0,0,0,0.1
                                C38.6,23.5,37.5,27.1,34.5,28.6 M28.1,9.2c4.9-2.1,10.6-1.4,14.8,2c0.9,0.7,1.6,1.7,2,2.7c0.4,1.4-1.5-0.1-1.8-0.3
                                c-1.3-0.9-2.8-1.6-4.3-2.2c-8.3-2.5-16.2,2.1-21.1,9.3c-2,3.2-3.5,6.6-4.5,10.2c-0.1,0.4-0.2,0.9-0.4,1.3
                                c-0.2,0.4-0.1-1.1-0.1-1.1c0.2-1.5,0.5-3,0.9-4.5C15.6,18.9,20.9,12.5,28.1,9.2 M28.2,51.1V33.6c0.5,0.1,1,0.1,1.5,0.1
                                c2.3,0,4.5-0.6,6.5-1.8v19.2c0.1,1.3-0.3,2.6-1,3.7c-0.7,0.8-1.8,1.3-2.9,1.2c-1.1,0-2.1-0.4-2.9-1.2
                                C28.4,53.8,28.1,52.5,28.2,51.1"/>
                        </g>
                    </g>
                </g>
            }
            {
                type == ICONS.TECHNICUS && <g id="Group_341" transform="translate(0 3)">
                    <g>
                        <g id="Group_162" transform="translate(0 0)">
                            <path id="Path_40" d="M56,34.4c0-0.8-0.3-1.2-1.2-1.2c-1.4,0-2.7,0.1-4.1,0c-1,0-1.3,0.5-1.3,1.4c0,1.2,0,2.3,0,3.5
                                c0,0.9-0.2,1.3-1.2,1.3c-1.6,0-3.2,0.1-4.9-0.1c-0.5-0.1-0.9-0.5-1-1c-0.1-6.2-0.1-12.5,0-18.7c0.1-0.5,0.5-0.9,1-1
                                c1.7-0.1,3.3-0.1,5,0c0.5,0.1,0.9,0.5,1,1c0.1,1.1,0.1,2.1,0.1,3.2c0,0.9,0.3,1.3,1.2,1.3c1.4,0,2.7,0,4.1,0
                                c0.9,0,1.3-0.3,1.2-1.2c0-1.9,0-3.9,0-5.8c0-3-1.2-4.1-4.2-4.1c-3.9,0-7.8,0-11.7,0c-3.4,0-4.5,1-4.5,4.4c0,2.8,0,5.6,0,8.6H12.3
                                c-3,0-4.2,0.9-4.3,3.3c0,2.4,1.2,3.3,4.3,3.3h23.3c0,3.1,0,5.9,0,8.7c0,2.4,1.1,3.7,3.5,3.7c4.5,0.1,8.9,0.1,13.4,0
                                c1.7,0.2,3.3-1.1,3.4-2.9c0-0.2,0-0.4,0-0.6C56,39.2,56,36.8,56,34.4 M12.8,29.7c-0.1,0.1-0.2,0.2-0.3,0.3
                                c-0.2,0.2-0.3,0.3-0.5,0.5c-0.1-0.1-0.2-0.2-0.3-0.3s-0.2-0.2-0.3-0.3c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.1-0.2-0.1-0.3
                                c-0.1-0.4,0.5-0.9,0.9-1.7c0.6,0.7,1.2,1.2,1.2,1.6C13.1,29.4,13,29.5,12.8,29.7"/>
                        </g>
                    </g>
                </g>
            }
            {
                type == ICONS.LIVE && <g id="_21">
                    <path d="M12.8,32c0-5.6,2-11,5.5-15.3c0.8-1,0.7-2.5-0.3-3.4c-1-0.8-2.5-0.7-3.4,0.3c-8.8,10.7-8.8,26.1,0,36.7
                        c0.5,0.5,1.1,0.9,1.8,0.9c0.6,0,1.1-0.2,1.5-0.6c1-0.8,1.2-2.4,0.3-3.4c0,0,0,0,0,0C14.7,43,12.8,37.6,12.8,32z"/>
                    <circle cx="32" cy="32" r="4.8"/>
                    <path d="M44.1,23.5c-0.5-1.2-2-1.7-3.2-1.2s-1.7,2-1.2,3.2c0.1,0.1,0.1,0.3,0.2,0.4c2.1,3.7,2.1,8.3,0,12
                        c-0.7,1.1-0.3,2.6,0.8,3.3c0,0,0,0,0,0c0.4,0.2,0.8,0.3,1.2,0.3c0.8,0,1.6-0.4,2.1-1.2C47.1,35.2,47.1,28.9,44.1,23.5L44.1,23.5z"
                        />
                    <path d="M23.1,22.7c-1.1-0.7-2.6-0.3-3.3,0.8c0,0,0,0,0,0c-3,5.2-3,11.6,0,16.8c0.4,0.8,1.2,1.2,2.1,1.2
                        c0.4,0,0.9-0.1,1.2-0.3c1.1-0.7,1.5-2.2,0.8-3.3c0,0,0,0,0,0c-2.1-3.7-2.1-8.3,0-12C24.6,24.8,24.2,23.4,23.1,22.7L23.1,22.7z"/>
                    <path d="M49.4,13.6c-0.8-1-2.4-1.2-3.4-0.3c-1,0.8-1.2,2.4-0.3,3.4l0,0c7.3,8.9,7.3,21.7,0,30.6
                        c-0.8,1-0.7,2.5,0.3,3.4c0,0,0,0,0,0c0.4,0.4,1,0.6,1.5,0.6c0.7,0,1.4-0.3,1.8-0.9C58.2,39.7,58.2,24.3,49.4,13.6L49.4,13.6z"/>
                </g>
            }
            {
                type == ICONS.MODULE && <g>
                    <path d="M53,29.7L32,42.3L11,29.7c-0.9-0.6-2.2-0.3-2.7,0.7S8,32.6,9,33.2c0,0,0,0,0,0l22,13.2c0.6,0.4,1.4,0.4,2.1,0
                        l22-13.2c0.9-0.6,1.3-1.8,0.7-2.7S53.9,29.2,53,29.7L53,29.7z"/>
                    <path d="M53,38.9L32,51.4L11,38.9c-0.9-0.6-2.2-0.3-2.7,0.7S8,41.7,9,42.3l22,13.2c0.6,0.4,1.4,0.4,2.1,0l22-13.2
                        c0.9-0.6,1.3-1.8,0.7-2.7C55.1,38.6,53.9,38.3,53,38.9L53,38.9z"/>
                    <path d="M32,37.3c-1.1,0-2.1-0.3-3.1-0.8l-20-12c-0.9-0.6-1.3-1.8-0.7-2.7c0.2-0.3,0.4-0.5,0.7-0.7l20-12
                        c1.9-1.1,4.2-1.1,6.1,0l20,12c0.9,0.6,1.3,1.8,0.7,2.7c-0.2,0.3-0.4,0.5-0.7,0.7l-20,12C34.1,37,33.1,37.3,32,37.3z M13.9,22.8
                        L31,33c0.6,0.4,1.4,0.4,2,0l17.1-10.3L33,12.5c-0.6-0.4-1.4-0.4-2,0l0,0L13.9,22.8z"/>
                </g>
            }
            {
                type == ICONS.MAILGUN && 
                <g id="Mailgun-Homepage">
                    <g id="Homepage-Mailgun-Desktop" transform="translate(-618.000000, -7475.000000)">
                        <g id="Signup-Banner" transform="translate(0.000000, 7357.000000)">
                            <g id="Group" transform="translate(232.000000, 112.000000)">
                                <g id="_x30_4-Icons_x2F_Icons_x2F_Mailgun" transform="translate(386.475000, 6.475000)">
                                    <path id="MG-Icon" d="M31.5,7.5c13.2,0,24,10.8,24,24c0,4.3-3.5,7.7-7.7,7.7c-1.4,0-2.8-0.4-4.1-1.2L43.6,38
                                        l-0.1,0.1c-2.4,4.4-7,7.1-12,7.1c-7.6,0-13.7-6.2-13.7-13.7S24,17.8,31.5,17.8S45.3,24,45.3,31.5c0,1.4,1.1,2.5,2.5,2.5
                                        c1.4,0,2.5-1.1,2.5-2.5c0-10.4-8.4-18.8-18.8-18.8c-10.4,0-18.8,8.4-18.8,18.8s8.4,18.8,18.8,18.8c5.5,0,10.7-2.4,14.3-6.6
                                        l4,3.4c-4.6,5.4-11.2,8.5-18.3,8.5c-13.2,0-24-10.8-24-24S18.3,7.5,31.5,7.5z M31.5,23c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5
                                        s8.5-3.8,8.5-8.5S36.2,23,31.5,23z M31.5,28.1c1.9,0,3.4,1.5,3.4,3.4c0,1.9-1.5,3.4-3.4,3.4c-1.9,0-3.4-1.5-3.4-3.4
                                        C28.1,29.6,29.6,28.1,31.5,28.1z"/>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            }
        </svg>
    </div>
}